<template>
  <div style="padding: 20px; height: 100%; box-sizing: border-box">
    <div class="cf" style="padding:10px">
      <div class="fl">
        <el-button type="primary" @click="bind()" size="mini">绑定货主</el-button>
        <el-select v-model="search.platformId" placeholder="请选择场站" size="mini" filterable style="margin: 0 10px"
          @change="changePlatform()">
          <el-option v-for="item in platformList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
        <el-select v-model="search.tenantId" placeholder="请选择企业" size="mini" filterable @change="init()">
          <el-option v-for="item in tenantList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </div>
      <div class="fr">
        <el-tooltip class="item" effect="dark" content="查询" placement="top">
          <el-button size="mini" @click="init()" circle icon="el-icon-search">
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <el-table :data="data" border size="mini" style="width: 100%" height="80%" v-loading="loading"
      highlight-current-row>
      <template slot="empty">
        <el-empty></el-empty>
      </template>
      <el-table-column prop="platformName" label="场站名称" min-width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column prop="createTenantName" label="二房东名称" min-width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column prop="tenantName" label="企业名称" min-width="180" show-overflow-tooltip
        align="center"></el-table-column>
      <el-table-column fixed="right" width="400" label="操作" align="center">
        <template v-slot="scope">
          <el-button size="mini" type="text" @click="unBind(scope.row)">解除绑定</el-button>
        </template>
      </el-table-column>
    </el-table>
    <detail ref="detail" @init="init()" />
  </div>
</template>

<script>
import detail from './components/detail'

export default {
  data() {
    return {
      data: [],
      allAlign: 'center',
      loading: false,
      tableHeight: window.innerHeight - 238 + 'px',
      search: {
        platformName: '',
        tenantName: ''
      },
      tenantList: [],
      platformList: []
    }
  },
  components: { detail },
  mounted() {
    this.$axios.get('/account/platform/all').then(res => {
      this.platformList = res.data.data
      this.$set(this.search, 'platformId', this.platformList[0].id)
      this.changePlatform()
    }).catch(() => {
    })
    this.$validate.ToDocumentTitle()
  },
  methods: {
    changePlatform() {
      const params = {
        headers: {
          platformId: this.search.platformId
        }
      }
      this.$axios.get('/account/platform/listTenant', params).then(tenantRes => {
        this.tenantList = tenantRes.data.data
        if (this.tenantList.length > 0) {
          this.$set(this.search, 'tenantId', this.tenantList[0].id)
          this.init()
        } else {
          this.$set(this.search, 'tenantId', '')
          this.data = []
        }
      }).catch(() => {
      })
    },
    init() {
      this.$set(this, 'loading', true)
      const params = {
        params: {
          platformId: this.search.platformId,
          createTenantId: this.search.tenantId
        }
      }
      this.$axios.get('/account/platform/tenant/second', params).then(res => {
        this.data = res.data.data
        this.loading = false
      }).catch(err => {
        console.log('model Err:', err)
        this.$set(this, 'loading', false)
      })
    },

    bind() {
      const e = {
        platformId: this.search.platformId,
        platformList: this.platformList,
        createTenantId: this.search.tenantId,
        tenantList: this.tenantList,
        bindTenantList: this.data
      }
      this.$refs.detail.display(e)
    },

    unBind(row) {
      this.$confirm(`确定解除绑定吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          id: row.id,
          del: true
        }
        this.$axios.post(`/account/platform/tenant/second/update`, params).then(() => {
          this.$message.success(`解除绑定成功`)
          this.init()
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.cf {
  overflow: hidden
}

.fl {
  float: left;
}

.fr {
  float: right;
}
</style>
